/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RouteDtoModel, RouteDtoModelType } from "./RouteDtoModel"
import { RouteDtoModelSelector } from "./RouteDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  node: RouteDtoModelType;
}

/**
 * RouteDtoEdgeBase
 * auto generated base class for the model RouteDtoEdgeModel.
 */
export const RouteDtoEdgeModelBase = withTypedRefs<Refs>()(ModelBase
  .named('RouteDtoEdge')
  .props({
    __typename: types.optional(types.literal("RouteDtoEdge"), "RouteDtoEdge"),
    cursor: types.union(types.undefined, types.string),
    node: types.union(types.undefined, MSTGQLRef(types.late((): any => RouteDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class RouteDtoEdgeModelSelector extends QueryBuilder {
  get cursor() { return this.__attr(`cursor`) }
  node(builder: string | RouteDtoModelSelector | ((selector: RouteDtoModelSelector) => RouteDtoModelSelector) | undefined) { return this.__child(`node`, RouteDtoModelSelector, builder) }
}
export function selectFromRouteDtoEdge() {
  return new RouteDtoEdgeModelSelector()
}

export const routeDtoEdgeModelPrimitives = selectFromRouteDtoEdge().cursor
